import { TRootState } from "Redux/Reducers";

export const getLastOrganizerId = (state: TRootState) => state.organizer.lastUpdateId;
